module.exports = __webpack_public_path__ + "static/media/Serra_Console_Login_Animation_Demo_v18.217d3082.mp4";